exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point-set-dialog[data-v-1a348d64]{position:absolute;bottom:0;left:5px;right:0;z-index:99;padding:10px 20px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.3);box-shadow:0 2px 12px 0 rgba(0,0,0,.3);border-radius:4px;background-color:var(--contentBgColor)}.point-set-dialog .form-height[data-v-1a348d64]{height:400px;overflow:auto}[data-v-1a348d64] .el-form-item{margin-bottom:5px}.width-80[data-v-1a348d64]{width:80%}.width-50[data-v-1a348d64]{width:50%}", ""]);

// exports
